import { markdownToHtml } from './markdown';

/** Copia texto plano al portapapeles. */
export async function copyPlainText(text: string): Promise<void> {
  await navigator.clipboard.writeText(text);
}

/**
 * Copia HTML enriquecido (text/html + text/plain) para pegar en WordPress, etc.
 * Si ClipboardItem / write fallan, degrada a writeText con el HTML.
 */
export async function copyRichHtml(html: string, plainFallback: string): Promise<void> {
  try {
    await navigator.clipboard.write([
      new ClipboardItem({
        'text/html': new Blob([html], { type: 'text/html' }),
        'text/plain': new Blob([plainFallback], { type: 'text/plain' }),
      }),
    ]);
  } catch {
    await navigator.clipboard.writeText(html);
  }
}

/**
 * Convierte Markdown a HTML listo para el portapapeles.
 * Quita el wrapper `.md-table-wrap` (solo layout Blunticle) para mejor pegado en WP.
 */
export function htmlForClipboard(markdown: string): string {
  return markdownToHtml(markdown).replace(
    /<div class="md-table-wrap">([\s\S]*?)<\/div>/g,
    '$1',
  );
}
